import dayjs, { Dayjs } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import _, { get, set } from "lodash";
import moment, { MomentInput, Moment } from "moment";
import queryString from "query-string";
import AppConfig from "../config";
import apiClient from "./apiClient";
// import moment, { Moment } from 'moment';
import "moment/locale/en-gb";
import { message } from "antd";

let store: any;
export const injectStore = (_store: any) => {
  store = _store;
};

let accessData: string[] = [];

export const updateAccessData = (data: string[]) => {
  const commonAccess = [
    "/app/inbox",
    // '/app/dashboard',
    "/app/changePassword",
    "/app/profile",
    "/app/manage-company",
  ];
  accessData = [...commonAccess, ...data];
};

export const convertToQuery = (query: any) => {
  let url = "";

  if (query && Object.keys(query).length > 0) {
    const queryArr = Object.keys(query)
      .map((val) => `${val}=${query[val]}`)
      .join("&");
    url += `?${queryArr}`;
  }

  return url;
};

export const convertMinutesToHours = (value: number) => {
  if (value) {
    const num = value;
    const hours = num / 60;
    const rHours = Math.floor(hours);
    const minutes = (hours - rHours) * 60;
    const rMinutes = `${Math.round(minutes)}`;

    return `${rHours.toString().length === 1 ? `0${rHours}` : rHours}:${
      rMinutes.length === 1 ? `0${rMinutes}` : rMinutes
    }`;
  }

  return "00:00";
};

// "45 hours 46 minutes". A separate helper from convertMinutesToHours (which
// returns "45:46" and is used by the existing Time Report and other screens) so
// neither format changes under the other's feet.
//
// Takes minutes, not decimal hours: 2746 minutes is exactly 45h 46m, whereas
// going via 45.77 and multiplying the fraction back can land a minute off.
export const convertMinutesToHoursText = (value: number) => {
  const total = Math.max(0, Math.round(value || 0));
  const hours = Math.floor(total / 60);
  const minutes = total % 60;

  return `${hours} ${hours === 1 ? "hour" : "hours"} ${minutes} ${
    minutes === 1 ? "minute" : "minutes"
  }`;
};

export const TIME_ENABLED_STATUS = ["Created", "Returned", "Rejected"];

export const getStartAndEndWeek = (value: Dayjs) => {
  dayjs.extend(isoWeek);
  const date = dayjs(value);
  const selectedStartWeek = dayjs(date).startOf("isoWeek").startOf("day");
  console.log(selectedStartWeek.toISOString(), "start");
  const selectedEndWeek = dayjs(date).endOf("isoWeek");
  const selectedStartMonth = dayjs(date).startOf("month").startOf("day");
  const selectedEndMonth = dayjs(date).endOf("month");

  const startWeek =
    selectedStartWeek > selectedStartMonth
      ? selectedStartWeek
      : selectedStartMonth;
  const endWeek =
    selectedEndWeek < selectedEndMonth ? selectedEndWeek : selectedEndMonth;
  const startWeekDate = startWeek.format("D");
  const endWeekDate = endWeek.format("D");

  return { startWeek, endWeek, startWeekDate, endWeekDate };
};

export const parseQueryStr = (value: string) => queryString.parse(value);

export const validateAccess = (
  accessList: string[] | undefined,
  page: string | string[] | undefined = "",
  withPath: boolean = false,
): boolean => {
  // Guard clauses for undefined/null inputs
  if (!accessList || !Array.isArray(accessList)) {
    console.log("Invalid access list:", { accessList });
    return false;
  }

  if (page === undefined || page === null) {
    console.log("Page is undefined or null");
    return false;
  }

  // Clone the access list
  const userAccessList = [...accessList];

  // Admin access check
  if (userAccessList.includes("adminAccess")) {
    return true;
  }

  // If no page access is required (empty string or empty array), allow access
  if (page === "" || (Array.isArray(page) && page.length === 0)) {
    return true;
  }

  // Define pages that always return true
  const alwaysAccessiblePages = [
    "edit-employee",
    "edit-employees-hcm",
    "edit-employees-benefits",
    "edit-employees-compensation",
    "edit-employees-payroll",
    "edit-employees-t&a",
    "purchase-leave-form",
    "cash-out-form",
  ];

  const userInfo = store?.getState()?.userState?.userInfo;
  const isHelpDeskRole = userInfo?.roleData?.name === "HelpDesk";
  // HelpDesk may also open Live Tracking (it edits time-tracker records).
  const helpDeskAccessiblePages = isHelpDeskRole
    ? ["master-upload", "system-usage-entries-all", "attendance-requests-report", "attendance-mismatch-report"]
    : [];

  const isAdminRole =
    userInfo?.userType === "Admin" || userInfo?.roleData?.name === "Admin";
  const adminAccessiblePages = isAdminRole ? ["roles", "app/roles"] : [];

  try {
    // Handle string page
    if (typeof page === "string") {
      // Check if page is in always accessible pages
      if (alwaysAccessiblePages.includes(page)) {
        return true;
      }

      if (helpDeskAccessiblePages.includes(page)) {
        return true;
      }

      if (adminAccessiblePages.includes(page)) {
        return true;
      }

      // Add time-reports-view to access list if needed
      if (!userAccessList.includes("time-reports-view")) {
        userAccessList.push("time-reports-view");
      }

      // Handle path processing if withPath is true
      if (withPath && page.length > 0) {
        const processedPage = page.slice(
          5,
          page.indexOf(":") > 0 ? page.indexOf("/:") : page.length,
        );
        return userAccessList.includes(processedPage);
      }

      return userAccessList.includes(page);
    }

    // Handle array of pages
    if (Array.isArray(page)) {
      // Check if any page is accessible via user access list
      const hasAccess = page.some((p) => userAccessList.includes(p));
      if (hasAccess) return true;

      // Check if user has HelpDesk role and any page is in helpDeskAccessiblePages
      if (isHelpDeskRole) {
        return page.some((p) => helpDeskAccessiblePages.includes(p));
      }

      if (isAdminRole) {
        return page.some((p) => adminAccessiblePages.includes(p));
      }

      return false;
    }

    // If page is neither string nor array, deny access
    console.log("Invalid page type:", { page, type: typeof page });
    return false;
  } catch (error) {
    console.error("Error in validateAccess:", {
      error,
      accessList,
      page,
      withPath,
    });
    return false;
  }
};

export const downloadPrintPDF = async (
  url: string,
  data: any,
  isPrint = false,
) => {
  try {
    const response = await apiClient(url, "POST", data, {
      responseType: "blob",
    });

    if (!response) {
      throw new Error("No response received");
    }

    const blob = new Blob([response], { type: "application/pdf" });

    if (isPrint) {
      print(blob);
    } else {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      // link.href = blobUrl;
      // link.download = "timesheet.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }
  } catch (error) {
    console.error("Download/Print error:", error);
    message.error("Failed to download/print document");
  }
};

export const print = (data: Blob) => {
  const iframe = document.createElement("iframe");
  document.body.appendChild(iframe);

  iframe.style.display = "none";
  iframe.src = window.URL.createObjectURL(data);

  iframe.onload = () => {
    setTimeout(() => {
      iframe.focus();
      iframe.contentWindow?.print();
    }, 1);
  };
};

export const fetchBlobUrlFromUrl = async (url: string): Promise<string> => {
  const token = localStorage.getItem("ACCOUNTING_TOKEN");
  const response = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    throw new Error(`Failed to load file: ${response.status}`);
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

export const fetchAssetBlobUrl = (path: string): Promise<string> =>
  fetchBlobUrlFromUrl(`${AppConfig.API_URL}/${path}`);

export const convertQueryStr = (value: Record<string, unknown>) =>
  queryString.stringify(value);
export const download = (data: Blob, headers: Record<string, string>) => {
  const a = document.createElement("a");
  a.href = window.URL.createObjectURL(data);
  if (headers) {
    a.download = JSON.parse(
      headers["content-disposition"].split("filename=")[1].split(";")[0],
    );
  }
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const avatarLetter = (str: string) => (str ? str.charAt(0) : "");

export const getImageUrl = (path: string, title: string = "") => {
  if (!path) return require("../assets/images/empty_img.png").default;
  if (path.startsWith("accqrate-documents/")) {
    return `${AppConfig.API_URL}/${path}`;
  }
  return `${AppConfig.API_URL}/assets/${path}`;
};

export const emailValidate = (value: string) => {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return pattern.test(value) === false;
};

export const numberValidate = (value: string) => {
  const pattern = /^[0-9]*$/;

  return pattern.test(value) === false;
};

export const urlValidate = (value: string) => {
  const pattern =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g;

  return pattern.test(value) === false;
};
type SelectOption<T> = {
  label: string;
  value: keyof T;
} & T;

// Capture the current browser's timezone + short label (e.g. "IST" / "GMT" /
// "UTC"). Used to stamp document audit-trail events at the actor's own location,
// since the server clock is UTC and cannot infer where the user is.
export const getBrowserTimeZone = (): {
  timeZone: string;
  timeZoneLabel: string;
} => {
  let timeZone = "";
  let timeZoneLabel = "";
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const part = new Intl.DateTimeFormat(undefined, { timeZoneName: "short" })
      .formatToParts(new Date())
      .find((p) => p.type === "timeZoneName");
    timeZoneLabel = part?.value || "";
  } catch {
    /* Intl unavailable — server falls back to UTC rendering */
  }
  return { timeZone, timeZoneLabel };
};

export const convertSelectOptions = <T>(
  options: T[],
  label: keyof T | string[],
  value: keyof T,
): SelectOption<T>[] =>
  options.map((data) => {
    const formattedLabel =
      typeof label === "object"
        ? label.map((v) => _.get(data, v, v)).join(" ")
        : _.get(data, label);

    const formattedValue = _.get(data, value);
    return { label: formattedLabel, value: formattedValue, ...data };
  });

export const removeEmptyKeys = <T extends Record<string, any>>(
  values: T,
): Partial<T> => {
  const newValue: Partial<T> = {};

  Object.entries(values).forEach(([key, value]) => {
    const isObject =
      typeof value === "object" && value !== null && !Array.isArray(value);
    const isNotEmptyObject = isObject ? Object.keys(value).length > 0 : true;

    if (value !== "" && value !== 0 && value !== null && isNotEmptyObject) {
      newValue[key as keyof T] = value;
    }
  });

  return newValue;
};

export const navigateToPreviousAndNext = <T>(url?: string, params?: T) =>
  new Promise((resolve, reject) => {
    if (url) {
      apiClient(url, "GET", { params }).then((data) => {
        if (data?.result) {
          resolve(data.result);
        } else {
          reject();
        }
      });
    } else {
      reject();
    }
  });

export const getDocPath = (rawPath: string) => {
  if (!rawPath) return "";
  // Normalise Windows backslashes from old DB records
  const p = rawPath.replace(/\\/g, "/");
  if (p.startsWith("accqrate-documents/")) return `${AppConfig.API_URL}/${p}`;
  // Strip leading "assets/" so the backend S3 middleware receives the bare key
  const stripped = p.startsWith("assets/") ? p.slice("assets/".length) : p;
  return `${AppConfig.API_URL}/assets/${stripped}`;
};

export const checkMoment = (date: MomentInput) =>
  date && moment.isMoment(moment(date)) ? moment(date) : null;

export const checkDayjs = (date: any): Dayjs | null => {
  return date && dayjs.isDayjs(dayjs(date)) ? dayjs(date) : null;
};

const APP_CACHE = { data: {} };

export const SET_DATA = (key: string, value: unknown) => {
  set(APP_CACHE.data, key, value);
};

export const amountSeparator = (value: string) => {
  const amount = value ? parseFloat(value).toFixed(2) : "0.00";

  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const GET_DATA = (key: string) => get(APP_CACHE.data, key);

export const getTax = (tax?: TNumber) =>
  tax === "" ? store.getState().users.companyInfo?.tax : Number(tax);

export const CLEAR_DATA = () => set(APP_CACHE, "data", {});

const ALPHABET =
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const generateId = (ID_LENGTH: number = 5) => {
  let rtn = "";

  for (let i = 0; i < (ID_LENGTH || 5); i++) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
  }

  return rtn;
};

export const validateDateRange = (data: any) => {
  // Support both field name patterns: validFrom/validTo and startDate/endDate
  const validFrom = data?.validFrom || data?.startDate;
  const validTo = data?.validTo || data?.endDate;

  // Check if both dates are present
  if (validFrom && validTo) {
    const fromDate = dayjs(validFrom);
    const toDate = dayjs(validTo);

    // Check if validTo is before validFrom
    return fromDate.isBefore(toDate);
  }
  // If one of the dates is missing, validation is not required
  return true;
};
export const stringToHslColor = (str: string, s = 50, l = 50) => {
  let hash = 0;

  for (let i = 0; i < str?.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const h = hash % 360;

  return `hsl(${h}, ${s}%, ${l}%)`;
};
export const sanitize = (html: string) => {
  const d = document.createElement("div");
  d.innerHTML = html;

  return {
    dangerouslySetInnerHTML: {
      __html: d.innerHTML,
    },
  };
};

export const roundOf = (value?: TNumber, decimals = 2) =>
  Number(
    `${Math.round(`${value}e${decimals}` as unknown as number)}e-${decimals}`,
  );

export const parseAmount = (
  value?: TNumber,
  currency?: string,
  noFormat?: boolean,
) => {
  const newState = store.getState();
  const defaultCurrency = currency || newState.userState.companyInfo?.currency;
  const currencyData = newState.userState.userInfo?.currencies?.find(
    (v: { code: any }) => v.code === defaultCurrency,
  ) || {
    decimalLength: 2,
    format: ",",
  };
  const amt = parseFloat(
    value && !Number.isNaN(value)
      ? roundOf(value, currencyData.decimalLength).toString()
      : "0",
  )?.toFixed(currencyData.decimalLength);

  return noFormat
    ? Number(amt)
    : amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, currencyData.format);
};

export const formatDate = (date: MomentInput, withTime: boolean) =>
  date ? moment(date).format(withTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD") : "";
